import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-group',{attrs:{"name":_vm.validateName,"attribute":`fields.${_vm.validateName}`},scopedSlots:_vm._u([{key:"default",fn:function({ attrs }){return [_c(VTextField,_vm._b({attrs:{"outlined":"","type":_vm.feildType ? _vm.feildType : 'text',"autocomplete":"","dense":""},on:{"keyup":_vm.active},model:{value:(_vm.getModelValue),callback:function ($$v) {_vm.getModelValue=$$v},expression:"getModelValue"}},'v-text-field',attrs,false))]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }